import apiService from '@/services/apiService';

const actions = {
  getJoinProcedures({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/join-procedures/find-with-paging', payload)
        .then((response) => {
          commit('SET_JOIN_PROCEDURES', response.data.data.results);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getJoinProcedure({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`paxelmarket/join-procedures/${payload}`)
        .then((response) => {
          commit('SET_JOIN_PROCEDURE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderJoinProcedure({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/join-procedures/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postJoinProcedure({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelmarket/join-procedures', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putJoinProcedure({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelmarket/join-procedures/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delJoinProcedure({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`paxelmarket/join-procedures/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
    });
  },

};

export default actions;
